module.exports = __webpack_public_path__ + "img/connected.50754e65.png";